<div class="form-bg-wrapper py-5 px-3 px-md-4 mb-5 ">
    <div class="form-container mx-auto bg-white rounded-4 border p-4 p-md-5 shadow-sm">

        <header class="mb-4 d-flex justify-content-between">
            <div>
                <h1 class="h4 fw-bold text-dark-navy mb-1 font-inter-bold">Company Details</h1>
                <p class="text-secondary small mb-0">Fill in the details below to verify the company identity</p>
            </div>
            <!-- @if(mode == 'edit' && userType == 'admin'){
            <div class="d-flex align-items-center gap-3">
                <button (click)="mapCofanetForm()"
                    class="btn btn-view-report btn-sm rounded-2 text-primary fw-semibold d-inline-flex align-items-center gap-1">
                    Map Canon Request
                </button>
            </div>

            } -->

        </header>

        <form [formGroup]="verificationForm" (ngSubmit)="onSubmit()" novalidate class="mb-5">
            <div class="row g-4">

                <div class="col-12">
                    <label class="form-label small fw-semibold text-dark">Company Name
                        @if(verificationForm.get('companyName')?.errors?.['required']){
                        <span class="text-danger">*</span>
                        }
                    </label>
                    <input type="text" class="form-control" formControlName="companyName" id="companyName"
                        placeholder="Enter company name"
                        [ngClass]="{'invalid-field':verificationForm.get('companyName')?.touched && verificationForm.get('companyName')?.invalid}">
                </div>

                <div class="col-12">
                    <label class="form-label small fw-semibold text-dark">Registered Address
                        @if(verificationForm.get('registeredAddress')?.errors?.['required']){
                        <span class="text-danger">*</span>
                        }

                    </label>
                    <input type="text" class="form-control" formControlName="registeredAddress" id="registeredAddress"
                        placeholder="Enter registered address"
                        [ngClass]="{'invalid-field':verificationForm.get('registeredAddress')?.touched && verificationForm.get('registeredAddress')?.invalid}">
                </div>
                <div class="col-md-6">

                    <label class="form-label small fw-semibold text-dark">Country
                        @if(verificationForm.get('country')?.errors?.['required']){
                        <span class="text-danger">*</span>
                        }
                    </label>


                    <input type="text" class="form-control" formControlName="country" placeholder="Select Country"
                        id="country" [matAutocomplete]="auto"
                        [ngClass]="{'invalid-field': verificationForm.get('country')?.touched && verificationForm.get('country')?.invalid}">


                    <mat-autocomplete #auto="matAutocomplete">
                        @for (country of filteredCountries$ | async; track country) {
                        <mat-option [value]="country.name" class="small">
                            {{ country.name }}
                        </mat-option>
                        }
                    </mat-autocomplete>
                </div>

                <div class="col-md-6">
                    <label class="form-label small fw-semibold text-dark">Website</label>
                    <input type="text" class="form-control" formControlName="website" id="website"
                        placeholder="e.g. www.example.com">
                </div>

                <div class="col-md-6">
                    <label class="form-label small fw-semibold text-dark">Contact Person Name
                        @if(verificationForm.get('contactName')?.errors?.['required']){
                        <span class="text-danger">*</span>
                        }
                    </label>
                    <input type="text" class="form-control" formControlName="contactName" id="contactName"
                        placeholder="Enter contact name"
                        [ngClass]="{'invalid-field':verificationForm.get('contactName')?.touched && verificationForm.get('contactName')?.invalid}">
                </div>

                <div class="col-md-6">
                    <label class="form-label small fw-semibold text-dark">Email Address
                        @if(verificationForm.get('email')?.errors?.['required']){
                        <span class="text-danger">*</span>
                        }
                    </label>
                    <input type="email" class="form-control" formControlName="email" placeholder="Enter email address"
                        id="email"
                        [ngClass]="{'invalid-field':verificationForm.get('email')?.touched && verificationForm.get('email')?.invalid}">
                </div>

                <div class="col-md-6">
                    <label class="form-label small fw-semibold text-dark">Phone Number
                        @if(verificationForm.get('contactNos')?.errors?.['required']){
                        <span class="text-danger">*</span>
                        }
                    </label>
                    <input type="tel" inputmode="numeric" class="form-control" formControlName="contactNos"
                        id="contactNos" placeholder="Enter phone number"
                        (keypress)="($event.charCode >= 48 && $event.charCode <= 57) || $event.preventDefault()"
                        [ngClass]="{'invalid-field':verificationForm.get('contactNos')?.touched && verificationForm.get('contactNos')?.invalid}">
                </div>


                <div class="col-md-6">
                    <label class="form-label small fw-semibold text-dark">Type
                        @if(verificationForm.get('type')?.errors?.['required']){
                        <span class="text-danger">*</span>
                        }
                    </label>
                    <input type="text" class="form-control" formControlName="type" placeholder="Enter type" id="type"
                        [ngClass]="{'invalid-field':verificationForm.get('type')?.touched && verificationForm.get('type')?.invalid}">
                </div>
                @if(mode == 'edit'){
                <div class="col-md-6">
                    <label class="form-label small fw-semibold text-dark">Credit Recommendations
                        @if(verificationForm.get('creditRecommendation')?.errors?.['required']){
                        <span class="text-danger">*</span>
                        }
                    </label>
                    <input type="text" class="form-control" formControlName="creditRecommendation"
                        placeholder="Enter credit recommendation" id="creditRecommendation"
                        [ngClass]="{'invalid-field':verificationForm.get('creditRecommendation')?.touched && verificationForm.get('creditRecommendation')?.invalid}">
                </div>

                <div class="col-md-6">
                    <label class="form-label small fw-semibold text-dark">Assessment Comments
                        @if(verificationForm.get('assessmentComments')?.errors?.['required']){
                        <span class="text-danger">*</span>
                        }
                    </label>
                    <input type="text" class="form-control" formControlName="assessmentComments"
                        placeholder="Enter assessment comments" id="assessmentComments"
                        [ngClass]="{'invalid-field':verificationForm.get('assessmentComments')?.touched && verificationForm.get('assessmentComments')?.invalid}">
                </div>



                <div class="col-md-6">
                    <label class="form-label small fw-semibold text-dark">Risk Rating
                        @if(verificationForm.get('riskRating')?.errors?.['required']){
                        <span class="text-danger">*</span>
                        }
                    </label>
                    <input type="text" class="form-control" formControlName="riskRating" placeholder="Enter risk rating"
                        id="riskRating"
                        [ngClass]="{'invalid-field':verificationForm.get('riskRating')?.touched && verificationForm.get('riskRating')?.invalid}">
                </div>

                 <div class="col-md-6">
                    <label class="form-label small fw-semibold text-dark">Status
                        @if(verificationForm.get('status')?.errors?.['required']){
                        <span class="text-danger">*</span>
                        }
                    </label>
                    <input type="text" class="form-control" formControlName="status" placeholder="Enter status"
                        id="status"
                        [ngClass]="{'invalid-field':verificationForm.get('status')?.touched && verificationForm.get('status')?.invalid}">
                </div>

                }



                <div class="col-12 mt-4">
                    <label class="form-label small fw-semibold text-dark">Company Registration Certificate </label>
                    <div class="drop-zone p-4 rounded-4 text-center d-flex flex-column align-items-center justify-content-center position-relative"
                        [class.drag-active]="isDragOver" (dragover)="onDragOver($event)"
                        (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">

                        <input type="file" id="fileInput"
                            class="position-absolute w-100 h-100 opacity-0 top-0 start-0 cursor-pointer"
                            (change)="onFileSelected($event)" accept=".pdf,.jpg,.jpeg,.png">

                        <ng-container *ngIf="!uploadedFile; else fileUploadedTemplate">
                            <div
                                class="upload-icon-circle mb-3 d-flex align-items-center justify-content-center rounded-circle">
                                <i class="bi bi-cloud-arrow-up-fill text-primary fs-5"></i>
                            </div>
                            <div class="small fw-semibold text-dark mb-1">Click to upload or drag and drop</div>
                            <div class="text-muted x-small">PDF, JPG, PNG (max. 10MB)</div>
                        </ng-container>

                        <ng-template #fileUploadedTemplate>
                            <div
                                class="upload-icon-circle mb-3 d-flex align-items-center justify-content-center rounded-circle bg-success-light">
                                <i class="bi bi-file-earmark-check-fill text-success fs-5"></i>
                            </div>
                            <div class="small fw-semibold text-success mb-1">File Attached Successfully</div>
                            <div class="text-muted x-small fw-medium">{{ uploadedFile?.name }} ({{ (uploadedFile!.size /
                                1024 / 1024) | number:'1.1-2' }} MB)</div>
                        </ng-template>
                    </div>

                    @if(uploadedFiles && uploadedFiles.length > 0) {
                    <div class="file-list mb-4">
                        @for(file of uploadedFiles; track file){
                        <div class="file-item">
                            <div class="file-info" (click)="viewMediaFile(file)">
                                @if(file.contentType && file.contentType.includes('image')){
                                <img [src]="file.fileUrl" alt="" class="file-icon"
                                    style="max-height: 40px; max-width: 40px; object-fit: contain;">
                                }
                                @else if(file.contentType && file.contentType.includes('application/pdf')){
                                <i class="bi bi-file-earmark-pdf-fill file-icon"
                                    style="font-size: 1.5rem; color: #ef4444;"></i>
                                }
                                @else if(file.contentType && file.contentType.includes('application/msword')){
                                <i class="bi bi-file-earmark-word-fill file-icon"
                                    style="font-size: 1.5rem; color: #2b579a;"></i>
                                }
                                @else{
                                <i class="bi bi-file-earmark-text-fill file-icon"
                                    style="font-size: 1.5rem; color: #6c757d;"></i>
                                }

                                <div class="file-meta">
                                    <span class="file-name">{{file.fileName}}</span>
                                </div>
                            </div>
                            <button type="button" class="btn-remove-file" (click)="deleteMedia(file.id)">
                                <i class="bi bi-x-lg"></i>
                            </button>
                        </div>
                        }
                    </div>
                    }
                </div>
                @if(mode == 'edit' && userType == 'admin' || mode == 'create'){
                <div class="col-12 d-flex justify-content-end gap-3 mt-5 align-items-center">
                    <button type="button"
                        class="btn btn-link text-secondary text-decoration-none fw-semibold small px-3 py-2"
                        (click)="onCancel()">
                        Cancel
                    </button>
                    <button type="submit"
                        class="btn btn-submit-navy px-4 py-2.5 text-white fw-semibold small rounded-3">
                        Submit Verification
                    </button>
                </div>
                }

            </div>
        </form>


    </div>
</div>

@if (showAuditWarningMessage) {
<div class="custom-dialog-backdrop d-flex align-items-center justify-content-center">
    <div class="dialog-card bg-white rounded-4 p-4 shadow-lg border text-center" style="max-width: 420px;">

        <!-- Warning Aesthetic Accent Header -->
        <div class="bg-warning-subtle text-warning rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
            style="width: 56px; height: 56px;">
            <span class="fs-4">⚠️</span>
        </div>

        <h4 class="h5 fw-bold text-dark mb-2">Change Audit Status?</h4>
        <p class="text-secondary small mb-4 px-2">
            This file is flagged as <strong>Queued for Audit</strong>. To link it manually, the workflow needs to switch
            this audit flag to false.
        </p>

        <!-- Primary Split Action Buttons -->
        <div class="d-grid gap-2">
            <button type="button" class="btn btn-primary py-2 fw-semibold rounded-3" (click)="disableAuditAndProceed()">
                Turn Off Audit & Continue
            </button>
            <button type="button" class="btn btn-light py-2 fw-semibold text-secondary rounded-3"
                (click)="showAuditWarningMessage = false">
                Cancel Action
            </button>
        </div>
    </div>
</div>
}